export const sets = [
  {
    name: null,
    imageSrc: '/images/sets/set-1.png',
  },
  {
    name: null,
    imageSrc: '/images/sets/set-2.png',
  },
  {
    name: null,
    imageSrc: '/images/sets/set-3.png',
  },
  {
    name: null,
    imageSrc: '/images/sets/set-4.png',
  },
  {
    name: null,
    imageSrc: '/images/sets/set-5.png',
  },
]
